module.exports = {
          srcSet: __webpack_public_path__ + "5dab3a5f33af56c4db9dddda837ab78f-357.png"+" 357w",
          images:[ {path: __webpack_public_path__ + "5dab3a5f33af56c4db9dddda837ab78f-357.png",width: 357,height: 327}],
          src: __webpack_public_path__ + "5dab3a5f33af56c4db9dddda837ab78f-357.png",
          toString:function(){return __webpack_public_path__ + "5dab3a5f33af56c4db9dddda837ab78f-357.png"},
          
          width: 357,
          height: 327
        }